import styled from "styled-components";
import { Typography, Grid } from "@material-ui/core";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorIcon from "@material-ui/icons/Error";

export const STTitle = styled(Typography)`
  && {
    font-weight: 600;
    font-size: 1.2rem;
  }
`;

export const STPasswordRequirementsWrapper = styled(Grid)`
  && {
    padding-top: 36px;
    padding-bottom: 24px;
  }
`;

export const STUserTitle = styled(Typography)`
  && {
    font-weight: 600;
  }
`;

export const STPasswordRequirementsTitle = styled(Typography)`
  && {
    font-weight: 600;
    padding-bottom: 4px;
  }
`;

export const STPasswordRequirementsText = styled(Typography)`
  && {
    padding-left: 8px;
  }
`;

export const STErrorIcon = styled(ErrorIcon)`
  && {
    color: red;
  }
`;

export const STCheckCircleIcon = styled(CheckCircleIcon)`
  && {
    color: green;
  }
`;
